






















































































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { readAppConfigs, readUserProfile } from '@/store/main/getters';
import PageHeader from '../../../components/vui-luma/Ui/PageHeader.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import WorkTimesSettingsCard from '@/components/UserDetails/Modals/WorkTimesSettingsCard.vue';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import { dispatchConnectGoogleAuthenticator, dispatchDisconnectGoogleAuthenticator, dispatchUpdateUserProfile } from '@/store/main/actions';

@Component({
  components: {
    PageHeader,
    PageSeparator,
    WorkTimesSettingsCard,
    CustomSelectInput,
  },
})
export default class UserProfileEdit extends Vue {
  public isTgConnected = false;
  public containerClass = 'container page__container';
  public timezone = '';
  public country = '';
  public loadingState = {
    submit: false,
  };
  public GAQRcode: string = '';

  public created() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      this.isTgConnected = userProfile.is_tg_connected;
      this.timezone = userProfile.time_zone;
      this.country = userProfile.country_with_flag;
    }
  }

  get appConfigs() {
    return readAppConfigs(this.$store);
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public async handleSubmit() {
    this.loadingState.submit = true;
    const data = {
      time_zone: this.timezone,
      // country_with_flag: this.country,
    };
    await dispatchUpdateUserProfile(this.$store, data);
    // @ts-ignore
    this.showToast(this, this.$t('Changes saved'));
    this.loadingState.submit = false;
  }

  public handleChangeTZ(tz) {
    this.timezone = tz;
  }
  public handleChangeCountry(country) {
    this.country = country;
  }
  public async handleConnectGA() {
    const result = await dispatchConnectGoogleAuthenticator(this.$store);
    if (result) {
      this.GAQRcode = result;
    }
  }
  public async handleDisconnectGA() {
    const result = await dispatchDisconnectGoogleAuthenticator(this.$store);
  }
}
